<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" max-width="800px">
            <v-card>
                <v-card-title class="ma-0 pa-0">
                    <v-toolbar dark color="blue lighten-2" class="titlebar">
                        <v-btn icon dark @click="show = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Выбор Группы ВК</v-toolbar-title>
                    </v-toolbar>
                </v-card-title>
                <v-card-text >
                    <div class="content">
                    <v-container fluid class="container-main">
                        <v-row>
                        <v-col cols="4" v-for="vkGroup in vkGroups"
                            :key="vkGroup.id"
                        >
                            <v-card height="100%" class="align-self">
                                <v-card-title class="body-2 fill-height align-start">
                                    <v-container fluid class="pa-0 ma-0 px-2">
                                    <v-row justify="center">
                                        <v-avatar
                                            :tile="false"
                                        >
                                            <img
                                                    :src="vkGroup.photo_50"
                                                    :alt="vkGroup.name"
                                            >
                                        </v-avatar>
                                    </v-row>
                                    <v-row justify="center">
                                        {{vkGroup.name | truncate(24, '...')}}
                                    </v-row>
                                    <v-row justify="center">
                                        <v-col cols="6" class="px-0 mx-0" v-show="!mailingParam">
                                            <v-btn
                                                    text
                                                    small
                                                    hover
                                                    :href="constConfComp.baseURLApi
                                                    + '/authorize/before-connect-vk-group-token-vk?group_id='
                                                    + vkGroup.id + '&bot_id=' + botId"
                                            ><span class="body-2">Выбрать</span></v-btn>
                                        </v-col>
                                        <v-col cols="6"  class="px-0 mx-0" v-show="mailingParam">
                                            <v-btn
                                                    text
                                                    small
                                                    hover
                                                    :href="constConfComp.baseURLApi
                                                    + '/authorize/before-connect-vk-group-token-vk-mailing?group_id='
                                                    + vkGroup.id + '&bot_id=' + botId"
                                            ><span class="body-2">Выбрать</span></v-btn>
                                        </v-col>
                                    </v-row>
                                    </v-container>
                                </v-card-title>
                            </v-card>
                        </v-col>
                        </v-row>
                    </v-container>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import constConf from '../../../constconf'

export default {
    name: 'SelectGroupVkDialog',
    data() {
        return {
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false
        }
    },
    props: ['dialog', 'botId', 'mailingParam'],
    computed: {
        ...mapGetters({
            vkGroups: 'user/getVkGroups',
            loadedVkGroups: 'user/loadedVkGroups'
        }),
        show: {
            get() {
                return this.dialog
            },
            set(value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        },
        constConfComp() {
            return constConf
        }
    },
    watch: {
        dialog(value) {
            console.log('dialog value ' + value)
            if (value) {
                console.log('this.loadedVkGroups')
                if (!this.loadedVkGroups) {
                    this.$store.dispatch('user/loadVkGroups').then(response => {
                        if (response !== undefined) {
                            if (response.hasOwnProperty('success')) {
                                this.paramsSnackbar.color = 'success'
                                this.paramsSnackbar.text = response.success.text
                            } else {
                                this.paramsSnackbar.color = 'error'
                                this.paramsSnackbar.text = response.error.text
                            }
                            this.snackbar = true
                        } else {
                            console.log(response)
                        }
                    })
                }
            }
        }
    },
    created() {

    },
    filters: {
        truncate(text, length, suffix) { /// *.title | truncate(18, '...')*/
            if (text.length > length) {
                return text.substring(0, length) + suffix
            } else {
                return text
            }
        }
    }
}
</script>

<style scoped>
    .container-main {
        width: 100vw;
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
    .content {
        flex-grow: 1;
        overflow-x: auto;
    }
</style>
